import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CandidatesComponent } from '@references/protected/candidates/candidates.component';

const routes: Routes = [
  {
    path: '',
    component: CandidatesComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import(
            '@references/protected/candidates/list/candidates.list.module'
          ).then((m) => m.CandidatesListModule)
      },
      {
        path: ':id',
        loadChildren: () =>
          import(
            '@references/protected/candidates/show/candidates.show.module'
          ).then((m) => m.CandidatesShowModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CandidatesRoutingModule {}
